export class EntFeed {
	[x: string]: any;
	
	public id: number;
	public order_id: string;   
	public subline:number;
	public comm_month: Date;  
	public order_type:string;
	public order_date: any;  
	public orderFromDate: any;
	public orderToDate: any;
	public workOrder:string;
	public orderDate: any;
	public original_order_date: any;
	public net_revenue: DoubleRange;
	public comm_revenue: any;
	public nrc_revenue: any;
	public emp_id: any;
	public sales_rep_id: any;
	public product_name: string;
	public description: string;
	public customer_name: string;
	public customer_type: string;
	public source: string;
	public commission_owner: string;
	public contract_term: any;
	public renewal_amount: any;
	public renewal_preservation: any;
	public cal_run_id: any;
	public status: string;
	public last_modified_by: string;
	public last_modified_on: Date;
	public enterpriseStatus: string;
	public isEnterprise: boolean = false;
	public isEntRelease: boolean = false;
	
	constructor() {
		this.orderFromDate = null;
		this.orderToDate = null;
		this.workOrder = null;
		this.id = null;
		this.order_id = null;
		this.subline = null;
		this.comm_month = null;
		this.order_type = null;
		this.order_date = null;
		this.original_order_date = null;
		this.net_revenue = null;
		this.comm_revenue = null;
		this.nrc_revenue = null;
		this.emp_id = null;
		this.sales_rep_id = null;
		this.product_name = null;
		this.description = null;
		this.customer_name = null;
		this.customer_type = null;
		this.source = null;
		this.commission_owner = null;
		this.contract_term = null;
		this.renewal_amount = null;
		this.renewal_preservation = null;
		this.cal_run_id = null;
		this.last_modified_by = null;
		this.last_modified_on = null;
		this.status = null;
		this.enterpriseStatus = null;
		this.isEnterprise = null;
		this.isEntRelease = null;
	}
	
	
}
